export default "__VITE_ASSET__Bd_muh8E__"